/**
 * Alhup Map v3.2.1 — Formulario inline en página de producto (ES5 compatible)
 * Intercepta "Comprar ahora" y muestra el picker de ubicación
 * dentro de la misma página (sin redirigir).
 */
(function(){
'use strict';
if(window.__alhupMapLoaded)return;window.__alhupMapLoaded=true;

// === BLOQUEO CHECKOUT NATIVO (CAPA 1: CSS) ===
// Ocultar botones nativos de Shopify para forzar uso de nuestro formulario
(function(){
  if(!/\/products\//.test(window.location.pathname))return;
  var s=document.createElement('style');
  s.textContent=
    /* Ocultar formulario nativo de producto (botón Agregar al carrito de Shopify) */
    'product-form .add-to-cart-button,'+
    'product-form [data-testid="standalone-add-to-cart"],'+
    '.product-form__cart-submit,'+
    '.buy-buttons-block,'+
    'product-form-component,'+
    'product-form,'+
    /* Botones de pago dinámico (Shop Pay, PayPal, etc.) */
    '.shopify-payment-button,'+
    'shopify-accelerated-checkout,'+
    'shopify-accelerated-checkout-cart,'+
    '[data-shopify="payment-button"],'+
    '.dynamic-checkout__content,'+
    '#shopify-buyer-consent,'+
    /* Sticky add to cart nativo (respaldo CSS) */
    'sticky-add-to-cart,'+
    '.sticky-add-to-cart'+
    '{display:none!important;visibility:hidden!important;pointer-events:none!important;height:0!important;overflow:hidden!important;}';
  (document.head||document.documentElement).appendChild(s);
})();

// === BLOQUEO CHECKOUT NATIVO (CAPA 2: Fetch/XHR) ===
// Interceptar llamadas a /cart/add para evitar que se agreguen productos al carrito nativo
(function(){
  if(!/\/products\//.test(window.location.pathname))return;
  var _fetch=window.fetch;
  window.fetch=function(url,opts){
    var u=typeof url==='string'?url:(url&&url.url?url.url:'');
    if(u&&/\/cart\/add/i.test(u)){
      console.warn('[Alhup] Blocked fetch to /cart/add — use Alhup order form');
      return Promise.resolve(new Response('{}',{status:200,headers:{'Content-Type':'application/json'}}));
    }
    return _fetch.apply(this,arguments);
  };
  var _xhrOpen=XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open=function(method,url){
    if(url&&/\/cart\/add/i.test(url)){
      this._alhupBlocked=true;
      console.warn('[Alhup] Blocked XHR to /cart/add — use Alhup order form');
    }
    return _xhrOpen.apply(this,arguments);
  };
  var _xhrSend=XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send=function(){
    if(this._alhupBlocked){return;}
    return _xhrSend.apply(this,arguments);
  };
})();

// === COBERTURA PERÚ ===
var COB=[
{dep:'Lima',prov:'Lima',dist:'Lima',t:'24h'},{dep:'Lima',prov:'Lima',dist:'Miraflores',t:'24h'},
{dep:'Lima',prov:'Lima',dist:'San Isidro',t:'24h'},{dep:'Lima',prov:'Lima',dist:'Surco',t:'24h'},
{dep:'Lima',prov:'Lima',dist:'San Borja',t:'24h'},{dep:'Lima',prov:'Lima',dist:'La Molina',t:'24h'},
{dep:'Lima',prov:'Lima',dist:'Ate',t:'24h'},{dep:'Lima',prov:'Lima',dist:'Santa Anita',t:'24h'},
{dep:'Lima',prov:'Lima',dist:'El Agustino',t:'24h'},{dep:'Lima',prov:'Lima',dist:'San Juan de Lurigancho',t:'24h'},
{dep:'Lima',prov:'Lima',dist:'San Martin de Porres',t:'24h'},{dep:'Lima',prov:'Lima',dist:'Los Olivos',t:'24h'},
{dep:'Lima',prov:'Lima',dist:'Independencia',t:'24h'},{dep:'Lima',prov:'Lima',dist:'Comas',t:'24h'},
{dep:'Lima',prov:'Lima',dist:'Carabayllo',t:'24h'},{dep:'Lima',prov:'Lima',dist:'Puente Piedra',t:'24h'},
{dep:'Lima',prov:'Lima',dist:'Rimac',t:'24h'},{dep:'Lima',prov:'Lima',dist:'Breña',t:'24h'},
{dep:'Lima',prov:'Lima',dist:'Jesus Maria',t:'24h'},{dep:'Lima',prov:'Lima',dist:'Pueblo Libre',t:'24h'},
{dep:'Lima',prov:'Lima',dist:'Magdalena del Mar',t:'24h'},{dep:'Lima',prov:'Lima',dist:'San Miguel',t:'24h'},
{dep:'Lima',prov:'Lima',dist:'Lince',t:'24h'},{dep:'Lima',prov:'Lima',dist:'La Victoria',t:'24h'},
{dep:'Lima',prov:'Lima',dist:'San Luis',t:'24h'},{dep:'Lima',prov:'Lima',dist:'Surquillo',t:'24h'},
{dep:'Lima',prov:'Lima',dist:'Barranco',t:'24h'},{dep:'Lima',prov:'Lima',dist:'Chorrillos',t:'24h'},
{dep:'Lima',prov:'Lima',dist:'Villa El Salvador',t:'24h'},{dep:'Lima',prov:'Lima',dist:'Villa Maria del Triunfo',t:'24h'},
{dep:'Lima',prov:'Lima',dist:'San Juan de Miraflores',t:'24h'},{dep:'Lima',prov:'Lima',dist:'Lurigancho',t:'24h'},
{dep:'Lima',prov:'Lima',dist:'Chaclacayo',t:'24h'},{dep:'Lima',prov:'Lima',dist:'Cieneguilla',t:'24h'},
{dep:'Lima',prov:'Lima',dist:'Pachacamac',t:'24h'},{dep:'Lima',prov:'Lima',dist:'Lurin',t:'24h'},
{dep:'Lima',prov:'Lima',dist:'Punta Hermosa',t:'24h'},{dep:'Lima',prov:'Lima',dist:'Punta Negra',t:'24h'},
{dep:'Lima',prov:'Lima',dist:'San Bartolo',t:'24h'},{dep:'Lima',prov:'Lima',dist:'Santa Maria del Mar',t:'24h'},
{dep:'Lima',prov:'Lima',dist:'Ancon',t:'24h'},{dep:'Lima',prov:'Lima',dist:'Santa Rosa',t:'24h'},
{dep:'Callao',prov:'Callao',dist:'Callao',t:'24h'},{dep:'Callao',prov:'Callao',dist:'Bellavista',t:'24h'},
{dep:'Callao',prov:'Callao',dist:'La Perla',t:'24h'},{dep:'Callao',prov:'Callao',dist:'Carmen de la Legua',t:'24h'},
{dep:'Callao',prov:'Callao',dist:'Ventanilla',t:'24h'},{dep:'Callao',prov:'Callao',dist:'Mi Peru',t:'24h'},
{dep:'Callao',prov:'Callao',dist:'La Punta',t:'24h'},
{dep:'Lima',prov:'Huaral',dist:'Huaral',t:'48h'},{dep:'Lima',prov:'Huaura',dist:'Huacho',t:'48h'},
{dep:'Lima',prov:'Canete',dist:'San Vicente de Canete',t:'48h'},{dep:'Lima',prov:'Barranca',dist:'Barranca',t:'48h'},
{dep:'La Libertad',prov:'Trujillo',dist:'Trujillo',t:'48h'},{dep:'La Libertad',prov:'Trujillo',dist:'La Esperanza',t:'48h'},
{dep:'La Libertad',prov:'Trujillo',dist:'El Porvenir',t:'48h'},{dep:'La Libertad',prov:'Trujillo',dist:'Victor Larco Herrera',t:'48h'},
{dep:'La Libertad',prov:'Trujillo',dist:'Huanchaco',t:'48h'},{dep:'La Libertad',prov:'Trujillo',dist:'Florencia de Mora',t:'48h'},
{dep:'La Libertad',prov:'Trujillo',dist:'Laredo',t:'48h'},{dep:'La Libertad',prov:'Trujillo',dist:'Moche',t:'48h'},
{dep:'La Libertad',prov:'Trujillo',dist:'Salaverry',t:'48h'},
{dep:'Arequipa',prov:'Arequipa',dist:'Arequipa',t:'48h'},{dep:'Arequipa',prov:'Arequipa',dist:'Cerro Colorado',t:'48h'},
{dep:'Arequipa',prov:'Arequipa',dist:'Cayma',t:'48h'},{dep:'Arequipa',prov:'Arequipa',dist:'Yanahuara',t:'48h'},
{dep:'Arequipa',prov:'Arequipa',dist:'Jose Luis Bustamante y Rivero',t:'48h'},{dep:'Arequipa',prov:'Arequipa',dist:'Paucarpata',t:'48h'},
{dep:'Arequipa',prov:'Arequipa',dist:'Mariano Melgar',t:'48h'},{dep:'Arequipa',prov:'Arequipa',dist:'Miraflores',t:'48h'},
{dep:'Arequipa',prov:'Arequipa',dist:'Socabaya',t:'48h'},{dep:'Arequipa',prov:'Arequipa',dist:'Jacobo Hunter',t:'48h'},
{dep:'Arequipa',prov:'Arequipa',dist:'Sachaca',t:'48h'},
{dep:'Lambayeque',prov:'Chiclayo',dist:'Chiclayo',t:'48h'},{dep:'Lambayeque',prov:'Chiclayo',dist:'Jose Leonardo Ortiz',t:'48h'},
{dep:'Lambayeque',prov:'Chiclayo',dist:'La Victoria',t:'48h'},{dep:'Lambayeque',prov:'Chiclayo',dist:'Pimentel',t:'48h'},
{dep:'Lambayeque',prov:'Lambayeque',dist:'Lambayeque',t:'48h'},
{dep:'Piura',prov:'Piura',dist:'Piura',t:'48h'},{dep:'Piura',prov:'Piura',dist:'Castilla',t:'48h'},
{dep:'Piura',prov:'Piura',dist:'Veintiseis de Octubre',t:'48h'},{dep:'Piura',prov:'Sullana',dist:'Sullana',t:'48h'},
{dep:'Piura',prov:'Talara',dist:'Pariñas',t:'48h'},
{dep:'Ica',prov:'Ica',dist:'Ica',t:'48h'},{dep:'Ica',prov:'Ica',dist:'La Tinguiña',t:'48h'},
{dep:'Ica',prov:'Ica',dist:'Parcona',t:'48h'},{dep:'Ica',prov:'Chincha',dist:'Chincha Alta',t:'48h'},
{dep:'Ica',prov:'Pisco',dist:'Pisco',t:'48h'},{dep:'Ica',prov:'Nazca',dist:'Nazca',t:'48h'},
{dep:'Junin',prov:'Huancayo',dist:'Huancayo',t:'48h'},{dep:'Junin',prov:'Huancayo',dist:'El Tambo',t:'48h'},
{dep:'Junin',prov:'Huancayo',dist:'Chilca',t:'48h'},
{dep:'Ancash',prov:'Santa',dist:'Chimbote',t:'48h'},{dep:'Ancash',prov:'Santa',dist:'Nuevo Chimbote',t:'48h'},
{dep:'Ancash',prov:'Huaraz',dist:'Huaraz',t:'72h'},{dep:'Ancash',prov:'Huaraz',dist:'Independencia',t:'72h'},
{dep:'Cusco',prov:'Cusco',dist:'Cusco',t:'72h'},{dep:'Cusco',prov:'Cusco',dist:'Wanchaq',t:'72h'},
{dep:'Cusco',prov:'Cusco',dist:'Santiago',t:'72h'},{dep:'Cusco',prov:'Cusco',dist:'San Sebastian',t:'72h'},
{dep:'Cusco',prov:'Cusco',dist:'San Jeronimo',t:'72h'},
{dep:'Loreto',prov:'Maynas',dist:'Iquitos',t:'72h'},{dep:'Loreto',prov:'Maynas',dist:'San Juan Bautista',t:'72h'},
{dep:'Loreto',prov:'Maynas',dist:'Punchana',t:'72h'},{dep:'Loreto',prov:'Maynas',dist:'Belen',t:'72h'},
{dep:'San Martin',prov:'San Martin',dist:'Tarapoto',t:'72h'},{dep:'San Martin',prov:'San Martin',dist:'Morales',t:'72h'},
{dep:'San Martin',prov:'San Martin',dist:'La Banda de Shilcayo',t:'72h'},
{dep:'Tacna',prov:'Tacna',dist:'Tacna',t:'48h'},{dep:'Tacna',prov:'Tacna',dist:'Gregorio Albarracin Lanchipa',t:'48h'},
{dep:'Tacna',prov:'Tacna',dist:'Alto de la Alianza',t:'48h'},{dep:'Tacna',prov:'Tacna',dist:'Ciudad Nueva',t:'48h'},
{dep:'Cajamarca',prov:'Cajamarca',dist:'Cajamarca',t:'72h'},{dep:'Cajamarca',prov:'Cajamarca',dist:'Baños del Inca',t:'72h'},
{dep:'Puno',prov:'Puno',dist:'Puno',t:'72h'},{dep:'Puno',prov:'San Roman',dist:'Juliaca',t:'72h'},
{dep:'Ucayali',prov:'Coronel Portillo',dist:'Calleria',t:'72h'},{dep:'Ucayali',prov:'Coronel Portillo',dist:'Manantay',t:'72h'},
{dep:'Ucayali',prov:'Coronel Portillo',dist:'Yarinacocha',t:'72h'},
{dep:'Tumbes',prov:'Tumbes',dist:'Tumbes',t:'48h'},
{dep:'Ayacucho',prov:'Huamanga',dist:'Ayacucho',t:'72h'},{dep:'Ayacucho',prov:'Huamanga',dist:'San Juan Bautista',t:'72h'},
{dep:'Ayacucho',prov:'Huamanga',dist:'Jesus Nazareno',t:'72h'},
{dep:'Huanuco',prov:'Huanuco',dist:'Huanuco',t:'72h'},{dep:'Huanuco',prov:'Huanuco',dist:'Amarilis',t:'72h'},
{dep:'Huanuco',prov:'Huanuco',dist:'Pillco Marca',t:'72h'},
{dep:'Madre de Dios',prov:'Tambopata',dist:'Tambopata',t:'72h'},
{dep:'Apurimac',prov:'Abancay',dist:'Abancay',t:'72h'},{dep:'Apurimac',prov:'Andahuaylas',dist:'Andahuaylas',t:'72h'},
{dep:'Moquegua',prov:'Mariscal Nieto',dist:'Moquegua',t:'48h'},{dep:'Moquegua',prov:'Ilo',dist:'Ilo',t:'48h'}
];

var DEP_CODES={'Lima':'PE-LMA','Callao':'PE-CAL','Arequipa':'PE-ARE','La Libertad':'PE-LAL','Lambayeque':'PE-LAM','Piura':'PE-PIU','Ica':'PE-ICA','Junin':'PE-JUN','Ancash':'PE-ANC','Cusco':'PE-CUS','Loreto':'PE-LOR','San Martin':'PE-SAM','Tacna':'PE-TAC','Cajamarca':'PE-CAJ','Puno':'PE-PUN','Ucayali':'PE-UCA','Tumbes':'PE-TUM','Ayacucho':'PE-AYA','Huanuco':'PE-HUC','Madre de Dios':'PE-MDD','Apurimac':'PE-APU','Moquegua':'PE-MOQ','Amazonas':'PE-AMA','Huancavelica':'PE-HUV','Pasco':'PE-PAS'};

function norm(s){return(s||'').toLowerCase().trim().normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/\s+/g,' ');}
function findCov(d,p,di){var nd=norm(di),nde=norm(d);var m=COB.find(function(c){return norm(c.dist)===nd&&norm(c.dep)===nde;});if(!m)m=COB.find(function(c){return norm(c.dist)===nd;});if(!m&&nd.length>=3)m=COB.find(function(c){return norm(c.dist).indexOf(nd)>-1||nd.indexOf(norm(c.dist))>-1;});return m||null;}
function getProvCode(dep,prov){var nd=norm(dep),np=norm(prov).replace(/^provincia de /,'');if(nd==='lima')return(np==='lima'||np===''||np.indexOf('lima')>-1)?'PE-LMA':'PE-LIM';var k=Object.keys(DEP_CODES).find(function(x){return norm(x)===nd;});return k?DEP_CODES[k]:'';}
function el(id){return document.getElementById(id);}

// === ESTADO ===
var map,marker,lat=null,lng=null,addr='',dist='',prov='',dep='',covRes=null;
var pickerVisible=false,mapInited=false;
var pendingVariantId=null,pendingQty=1;
var gpsConfidence='none'; // none|low|medium|high
var gpsSource='none'; // none|map_click|search|gps_browser

function isProductPage(){return /\/products\//.test(window.location.pathname);}

// === PICKER UI ===
window.AlhupMap={};

AlhupMap.show=function(){
  var picker=el('alhup-location-picker');
  if(!picker)return;
  picker.style.display='block';
  pickerVisible=true;
  if(!mapInited){mapInited=initMap()!==false;}
  setTimeout(function(){if(map)map.invalidateSize();},300);
  picker.scrollIntoView({behavior:'smooth',block:'start'});
  // Ocultar sticky CTA cuando el picker está abierto
  var stickyCta=el('alhup-sticky-cta');
  if(stickyCta)stickyCta.style.display='none';
  // Track InitiateCheckout event
  if(typeof AlhupTrack!=='undefined'){AlhupTrack.initiateCheckout();}
  // Pre-warm API (Render.com cold start — sin esto el primer pedido tarda 30s)
  AlhupMap._warmApi();
  // Restaurar datos previos del usuario (si llenó y abandonó antes)
  AlhupMap._restoreFormData();
  // Iniciar countdown de urgencia (15 min por sesión)
  AlhupMap._startUrgencyTimer();
  // Inicializar contador de stock dinámico
  AlhupMap._initStockCounter();
  // Update order summary with pack info
  AlhupMap._updateSummary();
  // Populate department selects
  populateDeps();
  // Focus WhatsApp field for quick entry (both mobile and desktop)
  setTimeout(function(){
    var wa=el('alhup-whatsapp');
    if(wa){
      wa.focus();
      // On mobile, scroll to the whatsapp field after keyboard opens
      setTimeout(function(){wa.scrollIntoView({behavior:'smooth',block:'center'});},300);
    }
  },500);
  // Auto-trigger GPS immediately on mobile (Baymard: auto-detect location, reduces perceived fields)
  // GPS runs in background while user fills Step 1 — by time they finish, location is ready
  if(window.innerWidth<=768&&!lat&&!lng&&navigator.geolocation){
    AlhupMap._pendingGpsPrompt=false;
    AlhupMap._gpsPrompted=true;
    setTimeout(function(){AlhupMap.useGPS();},800);
  }else{
    AlhupMap._pendingGpsPrompt=false;
  }
};

AlhupMap.hide=function(){
  var picker=el('alhup-location-picker');
  if(picker)picker.style.display='none';
  pickerVisible=false;
  // Restaurar sticky CTA
  var stickyCta=el('alhup-sticky-cta');
  if(stickyCta)stickyCta.style.display='';
};

AlhupMap.toggle=function(){
  var body=el('alhup-picker-body');
  var arrow=el('alhup-toggle-arrow');
  if(!body)return;
  if(body.style.display==='none'){
    body.style.display='block';arrow.textContent='▲';
    if(map)setTimeout(function(){map.invalidateSize();},200);
  }else{
    body.style.display='none';arrow.textContent='▼';
  }
};

// === MAP ===
function initMap(){
  if(typeof L==='undefined'){console.warn('[Alhup] Leaflet no cargado — mapa deshabilitado');var mc=el('alhup-map-container');if(mc)mc.style.display='none';populateDeps();return false;}
  try{
    var center=[-12.046,-77.043];
    map=L.map('alhup-map').setView(center,12);
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',{attribution:'© OSM',maxZoom:19}).addTo(map);
    map.on('click',function(e){gpsSource='map_click';placeMarker(e.latlng.lat,e.latlng.lng);reverseGeo(e.latlng.lat,e.latlng.lng);});
    map.on('zoomend',function(){updateGpsConfidence();updateZoomWarning();});
    map.on('moveend',function(){if(lat)updateGpsConfidence();});
  }catch(e){console.warn('[Alhup] Error inicializando mapa:',e);var mc2=el('alhup-map-container');if(mc2)mc2.style.display='none';populateDeps();return false;}
  populateDeps();
  return true;
}

function updateGpsConfidence(){
  if(!lat||!lng){gpsConfidence='none';return;}
  if(gpsSource==='gps_browser'){gpsConfidence='high';}
  else if(gpsSource==='search'){gpsConfidence=map&&map.getZoom()>=15?'high':'medium';}
  else if(gpsSource==='map_click'){
    var z=map?map.getZoom():12;
    if(z>=16)gpsConfidence='high';
    else if(z>=14)gpsConfidence='medium';
    else gpsConfidence='low';
  }else{gpsConfidence='low';}
  updateConfidenceBadge();
}

function updateConfidenceBadge(){
  var badge=el('alhup-gps-confidence');
  if(!badge)return;
  if(gpsConfidence==='none'){badge.style.display='none';return;}
  badge.style.display='inline-flex';
  var labels={'high':'\uD83D\uDFE2 GPS preciso','medium':'\uD83D\uDFE1 GPS aproximado','low':'\uD83D\uDD34 GPS impreciso'};
  var colors={'high':'#dcfce7','medium':'#fef9c3','low':'#fee2e2'};
  var borders={'high':'#16a34a','medium':'#ca8a04','low':'#dc2626'};
  badge.textContent=labels[gpsConfidence]||'';
  badge.style.background=colors[gpsConfidence]||'#f3f4f6';
  badge.style.borderColor=borders[gpsConfidence]||'#d1d5db';
}

function updateZoomWarning(){
  var warn=el('alhup-zoom-warning');
  if(!warn)return;
  if(!lat||!lng){warn.style.display='none';return;}
  var z=map?map.getZoom():12;
  if(z<14&&gpsSource!=='gps_browser'){
    warn.style.display='flex';
    warn.innerHTML='\u26A0\uFE0F <span>Acerca el mapa para marcar tu casa con m\u00E1s precisi\u00F3n. El repartidor necesita la ubicaci\u00F3n exacta.</span>';
  }else{warn.style.display='none';}
}

function placeMarker(la,ln){lat=la;lng=ln;if(typeof L==='undefined'||!map){updateGpsConfidence();updateZoomWarning();return;}if(marker)map.removeLayer(marker);marker=L.marker([la,ln]).addTo(map);map.setView([la,ln],16);updateGpsConfidence();updateZoomWarning();}

function reverseGeo(la,ln){
  fetch('https://nominatim.openstreetmap.org/reverse?lat='+la+'&lon='+ln+'&format=json&addressdetails=1&accept-language=es',{headers:{'User-Agent':'AlhupStore/1.0'}})
  .then(function(r){return r.json();})
  .then(function(d){if(d&&d.address)processNom(d);}).catch(function(){
    var manualSelects=el('alhup-manual-selects');if(manualSelects)manualSelects.style.display='block';
    var showManual=el('alhup-show-manual');if(showManual)showManual.style.display='none';
  });
}

function processNom(d){
  var a=d.address||{};
  if(a.country_code&&a.country_code!=='pe'){
    AlhupMap._showError('\uD83D\uDCCD Solo hacemos entregas en Per\u00FA');
    var manualSelects=el('alhup-manual-selects');if(manualSelects)manualSelects.style.display='block';
    var showManual=el('alhup-show-manual');if(showManual)showManual.style.display='none';
    return;
  }
  dist=a.suburb||a.city_district||a.town||a.village||a.neighbourhood||'';
  prov=(a.city||a.county||a.municipality||'').replace(/^Provincia de /i,'').trim();
  dep=(a.state||a.region||'').replace(/ Region$/i,'').replace(/ ?\(?Metropolitana\)?$/i,'').replace(/^Provincia de /i,'').trim();
  addr=d.display_name||[dist,prov,dep].filter(Boolean).join(', ');
  // Auto-completar referencia con la mayor precisión posible
  var road=a.road||a.pedestrian||a.footway||a.residential||'';
  var hnum=a.house_number||'';
  var building=a.building||a.amenity||a.shop||a.office||'';
  var neighbourhood=a.neighbourhood||a.quarter||'';
  var refParts=[];
  if(road&&hnum)refParts.push(road+' '+hnum);
  else if(road)refParts.push(road);
  if(building)refParts.push(building);
  if(neighbourhood&&neighbourhood!==dist)refParts.push(neighbourhood);
  var autoRef=refParts.join(', ');
  var refEl=el('alhup-ref');
  if(refEl&&autoRef){
    refEl.value=autoRef;
    // Auto-reveal ref wrap and hide link since we have auto-filled data
    var refWrap=el('alhup-ref-wrap');if(refWrap)refWrap.style.display='block';
    var refLink=el('alhup-add-ref-link');if(refLink)refLink.style.display='none';
  }
  showAddr();checkCov();showExtraFields();
  syncSelects();
}

function showAddr(){
  var ae=el('alhup-detected-address');var at=el('alhup-address-text');
  if(addr&&ae&&at){at.textContent=addr;ae.style.display='block';}
}

function checkCov(){
  var ce=el('alhup-coverage-result');var ci=el('alhup-coverage-icon');var ct=el('alhup-coverage-text');
  var dp=el('alhup-delivery-promise');var dt=el('alhup-delivery-time');
  if(!ce)return;
  ce.style.display='block';ce.className='';
  var m=findCov(dep,prov,dist);
  if(m){
    covRes=m;var t=m.t==='24h'?'mañana':m.t==='48h'?'en 2-3 días':'en 3-5 días';
    ce.className='cov-green';ci.textContent='✅';ct.innerHTML='<strong>¡Tenemos cobertura!</strong> Entrega '+t+' — GRATIS';
    if(dp){dp.style.display='flex';if(dt)dt.textContent='Entrega '+t+' — Pago contra entrega';}
  }else if(dep){
    covRes=null;ce.className='cov-yellow';ci.textContent='🟡';ct.innerHTML='<strong>Entrega por agencia Shalom</strong> (3-5 días) — GRATIS';
    if(dp){dp.style.display='flex';if(dt)dt.textContent='Entrega en 3-5 días por agencia';}
  }else{covRes=null;ce.style.display='none';if(dp)dp.style.display='none';}
}

function showExtraFields(){
  // All fields are now visible by default (CSS change)
  // Just update progress indicator and GPS notice
  AlhupMap._updateProgress();
  AlhupMap._showGpsNotice();
  AlhupMap._updateSummary();
}

function populateDeps(){
  var s=el('alhup-dep');if(!s||s.options.length>1)return;
  var ds=COB.map(function(c){return c.dep;}).filter(function(v,i,a){return a.indexOf(v)===i;}).sort();
  ds.forEach(function(d){var o=document.createElement('option');o.value=d;o.textContent=d;s.appendChild(o);});
}

function syncSelects(){
  // Auto-rellenar los selectores de Departamento/Provincia/Distrito
  // Usar los valores exactos de la tabla de cobertura si hubo match
  populateDeps();
  var depSel=el('alhup-dep');
  var provSel=el('alhup-prov');
  var distSel=el('alhup-dist');
  if(!depSel)return;

  // Si encontramos cobertura, usar los valores exactos del match
  var targetDep=dep,targetProv=prov,targetDist=dist;
  if(covRes){
    targetDep=covRes.dep;
    targetProv=covRes.prov;
    targetDist=covRes.dist;
  }else{
    // Sin cobertura exacta, buscar el match más cercano en COB para auto-rellenar
    var nd=norm(dep);
    var cobMatch=COB.find(function(c){return norm(c.dep)===nd;});
    if(cobMatch)targetDep=cobMatch.dep;
  }

  if(!targetDep)return;

  // Setear departamento
  var depMatch=selectOption(depSel,targetDep);
  if(!depMatch)return;

  // Trigger onChange para poblar provincias
  var dv=depSel.value;
  provSel.innerHTML='<option value="">Provincia</option>';
  distSel.innerHTML='<option value="">Distrito</option>';
  var pp=COB.filter(function(c){return c.dep===dv;}).map(function(c){return c.prov;}).filter(function(v,i,a){return a.indexOf(v)===i;}).sort();
  pp.forEach(function(p){var o=document.createElement('option');o.value=p;o.textContent=p;provSel.appendChild(o);});

  // Setear provincia
  if(targetProv){
    var provMatch=selectOption(provSel,targetProv);
    if(provMatch){
      // Poblar distritos
      var pv=provSel.value;
      distSel.innerHTML='<option value="">Distrito</option>';
      var dd=COB.filter(function(c){return c.dep===dv&&c.prov===pv;}).map(function(c){return c.dist;}).sort();
      dd.forEach(function(x){var o=document.createElement('option');o.value=x;o.textContent=x;distSel.appendChild(o);});

      // Setear distrito
      if(targetDist){
        selectOption(distSel,targetDist);
      }
    }
  }

  // Actualizar variables globales
  dep=depSel.value||dep;
  prov=provSel.value||prov;
  dist=distSel.value||dist;
}

function selectOption(sel,val){
  // Intentar match exacto primero
  for(var i=0;i<sel.options.length;i++){
    if(sel.options[i].value===val){sel.value=val;return true;}
  }
  // Match normalizado
  var nv=norm(val);
  for(var j=0;j<sel.options.length;j++){
    var nopt=norm(sel.options[j].value);
    if(nopt&&nopt===nv){sel.value=sel.options[j].value;return true;}
  }
  // Match parcial
  for(var k=0;k<sel.options.length;k++){
    var np=norm(sel.options[k].value);
    if(np&&nv&&np.length>=3&&(np.indexOf(nv)>-1||nv.indexOf(np)>-1)){sel.value=sel.options[k].value;return true;}
  }
  return false;
}

AlhupMap.onDepChange=function(){
  var d=el('alhup-dep').value;var ps=el('alhup-prov');var ds=el('alhup-dist');
  ps.innerHTML='<option value="">Provincia</option>';ds.innerHTML='<option value="">Distrito</option>';
  if(!d)return;dep=d;
  var pp=COB.filter(function(c){return c.dep===d;}).map(function(c){return c.prov;}).filter(function(v,i,a){return a.indexOf(v)===i;}).sort();
  pp.forEach(function(p){var o=document.createElement('option');o.value=p;o.textContent=p;ps.appendChild(o);});
};

AlhupMap.onProvChange=function(){
  var d=el('alhup-dep').value;var p=el('alhup-prov').value;var ds=el('alhup-dist');
  ds.innerHTML='<option value="">Distrito</option>';if(!p)return;prov=p;
  var dd=COB.filter(function(c){return c.dep===d&&c.prov===p;}).map(function(c){return c.dist;}).sort();
  dd.forEach(function(x){var o=document.createElement('option');o.value=x;o.textContent=x;ds.appendChild(o);});
};

AlhupMap.onDistChange=function(){
  var d=el('alhup-dist').value;if(!d)return;dist=d;
  dep=el('alhup-dep').value;prov=el('alhup-prov').value;
  checkCov();showExtraFields();
  // Trigger progress update (enables confirm button pulse)
  AlhupMap._updateProgress();
};

AlhupMap.searchAddress=function(){
  var inp=el('alhup-search-input');
  var q=(inp||{}).value;if(!q||!q.trim())return;
  q=q.trim();
  gpsSource='search';
  // Normalizar: remover tildes
  var normalized=q.replace(/[áàä]/gi,'a').replace(/[éèë]/gi,'e').replace(/[íìï]/gi,'i').replace(/[óòö]/gi,'o').replace(/[úùü]/gi,'u').replace(/[ñ]/gi,'n');
  // Expandir abreviaciones peruanas comunes
  normalized=normalized.replace(/\bav\.?\b/gi,'avenida').replace(/\bjr\.?\b/gi,'jiron').replace(/\bcl\.?\b/gi,'calle').replace(/\burb\.?\b/gi,'urbanizacion').replace(/\bmz\.?\b/gi,'manzana').replace(/\blt\.?\b/gi,'lote').replace(/\bcdra\.?\b/gi,'cuadra').replace(/\bpsje\.?\b/gi,'pasaje').replace(/\bpj\.?\b/gi,'pasaje').replace(/\bprol\.?\b/gi,'prolongacion');
  // Remover indicadores de numero (NRO, N°, NUM, #) — Nominatim no los entiende
  normalized=normalized.replace(/\bnro\.?\s*/gi,'').replace(/\bn[°º]\.?\s*/gi,'').replace(/\bnum\.?\s*/gi,'').replace(/#\s*/g,'');
  // Limpiar puntos sueltos y espacios extra
  normalized=normalized.replace(/\.\s/g,' ').replace(/\.$/,'').replace(/\s+/g,' ').trim();
  // Estrategia 1: buscar con query normalizado
  AlhupMap._nomSearch(normalized+', Peru',function(d){
    if(d&&d.length){AlhupMap._handleResults(d);}
    else{AlhupMap._searchFallback(normalized,q);}
  });
};
// Estrategia 2: busqueda estructurada (street + city)
AlhupMap._searchFallback=function(normalized,original){
  var parts=normalized.split(/\s+/);
  var types=['jiron','avenida','calle','pasaje','prolongacion','alameda','malecon','boulevard','ovalo','plaza'];
  var ti=-1;for(var i=0;i<parts.length;i++){if(types.indexOf(parts[i].toLowerCase())>=0){ti=i;break;}}
  if(ti>=0){
    var ni=-1;for(var j=ti+1;j<parts.length;j++){if(/^\d+$/.test(parts[j])){ni=j;break;}}
    if(ni>=0){
      var street=parts.slice(ti,ni+1).join(' ');
      var rest=parts.slice(ni+1);
      var city=rest.length>0?rest[rest.length-1]:'lima';
      var structUrl='https://nominatim.openstreetmap.org/search?format=json&limit=5&addressdetails=1&countrycodes=pe&street='+encodeURIComponent(street)+'&city='+encodeURIComponent(city);
      fetch(structUrl,{headers:{'User-Agent':'AlhupStore/1.0'}})
      .then(function(r){return r.json();})
      .then(function(d){
        if(d&&d.length){AlhupMap._handleResults(d);}
        else{AlhupMap._searchLast(original);}
      }).catch(function(){AlhupMap._searchLast(original);});
      return;
    }
  }
  AlhupMap._searchLast(original);
};
// Estrategia 3: query original sin normalizar
AlhupMap._searchLast=function(original){
  AlhupMap._nomSearch(original+', Peru',function(d){
    if(d&&d.length){AlhupMap._handleResults(d);}
    else{AlhupMap._clearSuggestions();AlhupMap._showError('🔍 No encontramos esa dirección. Intenta escribir el distrito o ciudad.');}
  });
};
AlhupMap._nomSearch=function(query,cb){
  fetch('https://nominatim.openstreetmap.org/search?q='+encodeURIComponent(query)+'&format=json&limit=5&addressdetails=1&countrycodes=pe',{headers:{'User-Agent':'AlhupStore/1.0'}})
  .then(function(r){return r.json();}).then(cb).catch(function(){cb(null);});
};
AlhupMap._handleResults=function(d){
  if(d.length===1){var r=d[0];placeMarker(parseFloat(r.lat),parseFloat(r.lon));processNom(r);AlhupMap._clearSuggestions();}
  else{AlhupMap._showSuggestions(d);}
};

// Mostrar sugerencias de dirección
AlhupMap._showSuggestions=function(results){
  AlhupMap._clearSuggestions();
  var inp=el('alhup-search-input');if(!inp)return;
  var wrap=inp.parentElement;
  var list=document.createElement('div');
  list.id='alhup-search-suggestions';
  list.style.cssText='position:absolute;top:100%;left:0;right:0;background:#fff;border:1px solid #d1d5db;border-top:none;border-radius:0 0 12px 12px;box-shadow:0 8px 24px rgba(0,0,0,0.1);max-height:200px;overflow-y:auto;z-index:100;';
  wrap.style.position='relative';
  for(var i=0;i<results.length;i++){
    var item=document.createElement('button');
    item.type='button';
    item.style.cssText='display:block;width:100%;text-align:left;padding:10px 14px;border:none;background:none;cursor:pointer;font-size:13px;color:#374151;border-bottom:1px solid #f3f4f6;transition:background 0.15s;';
    item.textContent=results[i].display_name.replace(/, Peru$/i,'').replace(/, Perú$/i,'');
    item.dataset.idx=i;
    item.addEventListener('mouseenter',function(){this.style.background='#f0fdf4';});
    item.addEventListener('mouseleave',function(){this.style.background='none';});
    (function(r){
      item.addEventListener('click',function(){
        placeMarker(parseFloat(r.lat),parseFloat(r.lon));processNom(r);
        inp.value=r.display_name.replace(/, Peru$/i,'').replace(/, Perú$/i,'');
        AlhupMap._clearSuggestions();
      });
    })(results[i]);
    list.appendChild(item);
  }
  wrap.appendChild(list);
  // Cerrar sugerencias al clickear fuera
  setTimeout(function(){
    document.addEventListener('click',function closeSug(e){
      if(!wrap.contains(e.target)){AlhupMap._clearSuggestions();document.removeEventListener('click',closeSug);}
    });
  },100);
};

AlhupMap._clearSuggestions=function(){
  var s=document.getElementById('alhup-search-suggestions');if(s)s.remove();
};

AlhupMap.useGPS=function(){
  if(!navigator.geolocation){AlhupMap._showError('GPS no disponible en este navegador');return;}
  // Prevent duplicate GPS calls (auto-trigger + manual tap race condition)
  if(AlhupMap._gpsRunning)return;
  AlhupMap._gpsRunning=true;
  if(!mapInited){mapInited=initMap()!==false;}
  var gpsBtn=el('alhup-gps-btn');
  var btnText=el('alhup-gps-btn-text');
  var btnLoad=el('alhup-gps-btn-loading');
  if(gpsBtn){gpsBtn.disabled=true;if(btnText)btnText.style.display='none';if(btnLoad)btnLoad.style.display='inline-flex';}
  // Safety net: if geolocation hangs beyond 20s, reset button (some Android browsers)
  var gpsSafetyTimer=setTimeout(function(){
    if(!AlhupMap._gpsRunning)return;
    AlhupMap._gpsRunning=false;
    if(gpsBtn){gpsBtn.disabled=false;if(btnText){btnText.textContent='📍 Detectar mi ubicación';btnText.style.display='inline';}if(btnLoad)btnLoad.style.display='none';}
    var manualSelects=el('alhup-manual-selects');var showManual=el('alhup-show-manual');
    if(manualSelects)manualSelects.style.display='block';
    if(showManual)showManual.style.display='none';
  },20000);
  navigator.geolocation.getCurrentPosition(function(p){
    clearTimeout(gpsSafetyTimer);
    AlhupMap._gpsRunning=false;
    if(gpsBtn){gpsBtn.disabled=false;if(btnText){btnText.textContent='✅ Ubicación detectada';btnText.style.display='inline';}if(btnLoad)btnLoad.style.display='none';}
    gpsSource='gps_browser';placeMarker(p.coords.latitude,p.coords.longitude);reverseGeo(p.coords.latitude,p.coords.longitude);
    // Auto-show ref link when GPS detected
    var refLink=el('alhup-add-ref-link');if(refLink)refLink.style.display='inline-block';
  },function(err){
    clearTimeout(gpsSafetyTimer);
    AlhupMap._gpsRunning=false;
    if(gpsBtn){gpsBtn.disabled=false;if(btnText){btnText.textContent='📍 Detectar mi ubicación';btnText.style.display='inline';}if(btnLoad)btnLoad.style.display='none';}
    if(err.code===1){AlhupMap._showError('📍 Activa el permiso de ubicación en tu navegador, o selecciona tu distrito manualmente abajo.');}
    else if(err.code===2){AlhupMap._showError('📍 Ubicación no disponible. Selecciona tu distrito manualmente abajo.');}
    else{AlhupMap._showError('📍 Tiempo de espera agotado. Selecciona tu distrito manualmente.');}
    // Auto-show manual selects when GPS fails (hidden by default for cleaner UX)
    var manualSelects=el('alhup-manual-selects');var showManual=el('alhup-show-manual');
    if(manualSelects)manualSelects.style.display='block';
    if(showManual)showManual.style.display='none';
  },{enableHighAccuracy:true,timeout:15000});
};

// Enter en buscador
document.addEventListener('keydown',function(e){if(e.target&&e.target.id==='alhup-search-input'&&e.key==='Enter'){e.preventDefault();AlhupMap.searchAddress();}});

// === CONFIRMAR PEDIDO ===
AlhupMap.confirmOrder=function(){
  // Hide previous inline errors
  AlhupMap._hideError();

  // Validate WhatsApp first (Step 1)
  var wv=(el('alhup-whatsapp')||{value:''}).value.replace(/\D/g,'');
  if(!wv||wv.length<9||!wv.startsWith('9')){
    AlhupMap._showError('📱 Ingresa tu número de WhatsApp (9 dígitos, empieza con 9)');
    var wi=el('alhup-whatsapp');if(wi)wi.focus();return;
  }
  var waErr=el('alhup-wa-err');if(waErr)waErr.style.display='none';

  // Single fullname field (Baymard best practice)
  var fullname=(el('alhup-fullname')||{value:''}).value.trim();
  if(!fullname||fullname.length<3){
    AlhupMap._showError('📝 Ingresa tu nombre completo para la entrega');
    var fnEl=el('alhup-fullname');if(fnEl)fnEl.focus();return;
  }
  // Split into first/last name for API
  var nameParts=fullname.split(/\s+/);
  var nm=nameParts[0]||'';
  var ln=nameParts.length>1?nameParts.slice(1).join(' '):'.';

  // Validate location (Step 2) — selects OR GPS
  if(!dist&&!dep){
    AlhupMap._showError('📍 Selecciona tu ubicación: usa el GPS o elige tu departamento, provincia y distrito');
    var depSel=el('alhup-dep');if(depSel)depSel.focus();return;
  }

  // Soft zoom warning (not blocking if selects are filled)
  if(lat&&lng&&gpsSource!=='gps_browser'&&map&&map.getZoom()<14){
    var distSel=el('alhup-dist');
    var hasDistFromSelect=distSel&&distSel.value;
    if(!hasDistFromSelect){
      AlhupMap._showError('🔍 Acerca el mapa un poco más para marcar tu ubicación exacta');
      return;
    }
    // If district is selected from dropdown, allow proceeding even with low zoom
  }

  var waFull='51'+wv;
  var ref=(el('alhup-ref')||{value:''}).value.trim();
  var btn=el('alhup-confirm-btn');if(btn){btn.disabled=true;var _btnText=el('alhup-confirm-btn-text');if(_btnText)_btnText.textContent='Procesando...';}

  // Agregar producto al carrito
  var form=document.querySelector('form[action*="/cart/add"]');
  var variantInput=form?form.querySelector('[name="id"],input[name="id"],select[name="id"]'):null;
  var variantId=pendingVariantId||(variantInput?variantInput.value:null);
  var qtyInput=form?form.querySelector('[name="quantity"]'):null;
  var qty=pendingQty||(qtyInput?parseInt(qtyInput.value)||1:1);

  // Properties para cada item
  var itemProps={
    'WhatsApp':'+'+waFull,
    'Departamento':dep,'Provincia':prov,'Distrito':dist,
    'Dirección':addr,'Cobertura':covRes?covRes.t:'shalom',
    'Tiempo de entrega':covRes?(covRes.t==='24h'?'Mañana':covRes.t==='48h'?'2-3 días':'3-5 días'):'3-5 días'
  };
  if(ref)itemProps['Referencia']=ref;
  if(lat)itemProps['Latitud']=String(lat);if(lng)itemProps['Longitud']=String(lng);
  if(lat&&lng)itemProps['Google Maps']='https://www.google.com/maps?q='+lat+','+lng;
  itemProps['GPS Verificado']=(lat&&lng)?'Sí':'No';
  itemProps['GPS Confianza']=gpsConfidence||'none';
  itemProps['GPS Fuente']=gpsSource||'none';
  if(nm)itemProps['Nombre']=nm;if(ln)itemProps['Apellidos']=ln;

  // Leer pack seleccionado (si existe)
  var packInfo=window.__alhupSelectedPack||{qty:1,price:89,pack:'1'};
  var orderQty=1; // Siempre 1 pack (el pack ya incluye la cantidad de frascos)

  // Usar variant_id del pack seleccionado (prioridad sobre el formulario)
  if(packInfo.variantId){variantId=packInfo.variantId;}

  if(!variantId){
    AlhupMap._showError('Error al identificar el producto. Recarga la p\u00E1gina e intenta de nuevo.');
    if(btn){btn.disabled=false;var _btnText=el('alhup-confirm-btn-text');if(_btnText)_btnText.textContent='Confirmar pedido \u2014 Pago al recibir';}
    return;
  }

  // Construir datos para el API de creación directa
  var shortAddr=dist;
  if(addr){var parts=addr.split(',');shortAddr=parts.length>3?parts.slice(0,2).join(', ').trim():addr;}
  if(ref)shortAddr=ref+', '+shortAddr;

  var address2='';
  if(lat&&lng){
    var gps=lat.toFixed(7)+','+lng.toFixed(7);
    address2=ref?(ref+' | GPS:'+gps):('GPS:'+gps);
  }else if(ref){address2=ref;}

  var note=dist+', '+prov+', '+dep;
  if(ref)note=ref+' - '+note;
  if(lat&&lng)note+=' | GPS: '+lat+','+lng;

  var cartAttrs={
    '_delivery_lat':lat||'','_delivery_lng':lng||'',
    '_delivery_distrito':dist,'_delivery_provincia':prov,'_delivery_departamento':dep,
    '_delivery_full_address':addr,'_delivery_coverage':covRes?covRes.t:'shalom',
    '_delivery_confirmed':'true','_delivery_whatsapp':'+'+waFull,
    '_gps_confidence':gpsConfidence||'none','_gps_source':gpsSource||'none',
    '_gps_zoom':map?String(map.getZoom()):'0',
    'Departamento':dep,'Provincia':prov,'Distrito':dist,
    'Dirección':addr,'Teléfono':'+'+waFull,
    '_pack':packInfo.pack,'_pack_qty':String(orderQty),'_pack_price':String(packInfo.price)
  };
  if(ref){cartAttrs['_delivery_referencia']=ref;cartAttrs['Referencia']=ref;}
  if(lat&&lng){cartAttrs['_delivery_google_maps']='https://www.google.com/maps?q='+lat+','+lng;cartAttrs['GPS']=lat+','+lng;}
  if(nm)cartAttrs['_customer_name']=nm;if(ln)cartAttrs['_customer_lastname']=ln;
  if(typeof AlhupTrack!=='undefined'){
    var utms=AlhupTrack.getUtms();
    if(utms.utm_source)cartAttrs['_utm_source']=utms.utm_source;
    if(utms.utm_medium)cartAttrs['_utm_medium']=utms.utm_medium;
    if(utms.utm_campaign)cartAttrs['_utm_campaign']=utms.utm_campaign;
    if(utms.ttclid)cartAttrs['_ttclid']=utms.ttclid;
  }

  // Agregar propiedades del pack a las line item properties
  itemProps['Pack']=packInfo.pack+' frasco'+(packInfo.qty>1?'s':'');
  itemProps['Precio Pack']='S/'+packInfo.price;

  var orderData={
    firstName:nm||'',lastName:ln||'',
    phone:'+'+waFull,
    email:'wa'+wv+'@alhup.store',
    address1:shortAddr,address2:address2,
    city:dist,province:dep,provinceCode:getProvCode(dep,prov),
    country:'PE',departamento:dep,distrito:dist,
    items:[{variant_id:variantId,quantity:orderQty,price:String(packInfo.price)+'.00',properties:itemProps}],
    note:note,
    cartAttributes:cartAttrs
  };

  // Guardar datos en localStorage ANTES de enviar (recovery si falla)
  AlhupMap._saveFormData();

  // Feedback progresivo durante cold start (Render.com puede tardar 30s)
  AlhupMap._startProgressiveLoader();

  // Crear pedido via API del bot (sin redirect a checkout)
  var API_URL='https://alhup-whatsapp-bot.onrender.com/api/create-order';

  function submitOrder(attempt){
    var controller=(typeof AbortController!=='undefined')?new AbortController():null;
    var timeoutId=setTimeout(function(){if(controller)controller.abort();},attempt===1?35000:25000);
    var fetchOpts={
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body:JSON.stringify(orderData)
    };
    if(controller)fetchOpts.signal=controller.signal;
    fetch(API_URL,fetchOpts).then(function(res){clearTimeout(timeoutId);return res.json();})
    .then(function(data){
      if(data.success){
        AlhupMap._stopProgressiveLoader();
        AlhupMap._clearFormData();
        if(typeof fbq==='function')fbq('track','Purchase',{value:packInfo.price,currency:'PEN'});
        if(typeof AlhupTrack!=='undefined'){AlhupTrack.completePayment({price:packInfo.price});}
        showOrderSuccess(data.order_number||data.name||'',packInfo,fullname||'Cliente',wv);
      }else if(attempt<2){
        AlhupMap._loaderMsg('Reintentando envío...');
        setTimeout(function(){submitOrder(attempt+1);},800);
      }else{
        AlhupMap._stopProgressiveLoader();
        fallbackCheckout(wv,nm,ln,shortAddr,address2,dist,dep,prov,ref);
      }
    }).catch(function(err){
      clearTimeout(timeoutId);
      if(attempt<2){
        AlhupMap._loaderMsg('Servidor despertando, reintentando...');
        setTimeout(function(){submitOrder(attempt+1);},1200);
      }else{
        AlhupMap._stopProgressiveLoader();
        fallbackCheckout(wv,nm,ln,shortAddr,address2,dist,dep,prov,ref);
      }
    });
  }
  submitOrder(1);
};

function _escHtml(s){var d=document.createElement('div');d.appendChild(document.createTextNode(s));return d.innerHTML;}
// Mostrar pantalla de éxito inline + auto-redirect a WhatsApp
function showOrderSuccess(orderNum,packInfo,nombre,whatsapp){
  AlhupMap._markProgressDone();
  var picker=el('alhup-location-picker');
  if(!picker)return;
  var packLabel=packInfo.qty===1?'1 frasco':packInfo.qty+' frascos';
  var waUrl='https://wa.me/51910214077?text='+encodeURIComponent('Hola! Acabo de hacer mi pedido'+(orderNum?' #'+orderNum:'')+' de '+packLabel+' (S/'+packInfo.price+'). Mi WhatsApp: +51'+whatsapp+'. ¿Me confirman la entrega?');
  picker.innerHTML='<div class="alhup-order-success">'+
    '<div class="alhup-order-success__icon">'+
      '<svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#0d9668" stroke-width="2"><circle cx="12" cy="12" r="10"/><polyline points="16 9 10.5 14.5 8 12"/></svg>'+
    '</div>'+
    '<h3 class="alhup-order-success__title">¡Pedido registrado!</h3>'+
    (orderNum?'<p class="alhup-order-success__number">Pedido #'+orderNum+'</p>':'')+
    '<div class="alhup-order-success__details">'+
      '<p><strong>'+_escHtml(nombre)+'</strong>, tu pedido de <strong>'+packLabel+'</strong> por <strong>S/'+packInfo.price+'</strong> ha sido registrado exitosamente.</p>'+
      '<p>📲 Te estamos redirigiendo a WhatsApp para confirmar tu pedido...</p>'+
      '<p style="font-size:13px;color:#6b7280;margin-top:8px;">Si no se abre automáticamente, usa el botón de abajo.</p>'+
    '</div>'+
    '<div class="alhup-order-success__badges">'+
      '<span>📦 Envío gratis</span>'+
      '<span>💰 Pagas al recibir</span>'+
      '<span>📱 Confirmación por WhatsApp</span>'+
    '</div>'+
    '<a href="'+waUrl+'" target="_blank" rel="noopener" id="alhup-wa-fallback-btn" '+
      'style="display:flex;align-items:center;justify-content:center;gap:8px;padding:14px 24px;background:#25D366;color:#fff;border-radius:12px;font-weight:700;font-size:15px;text-decoration:none;margin-top:12px;transition:transform 0.2s,box-shadow 0.2s;" '+
      'onmouseenter="this.style.transform=\'scale(1.02)\';this.style.boxShadow=\'0 4px 16px rgba(37,211,102,0.4)\'" '+
      'onmouseleave="this.style.transform=\'scale(1)\';this.style.boxShadow=\'none\'">'+
      '<svg width="22" height="22" viewBox="0 0 24 24" fill="#fff"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>'+
      'Confirmar por WhatsApp</a>'+
  '</div>';
  picker.scrollIntoView({behavior:'smooth',block:'center'});
  // Auto-redirect a WhatsApp después de 1.5 segundos
  setTimeout(function(){window.open(waUrl,'_blank');},1500);
}

// Fallback: mostrar error inline y ofrecer WhatsApp (sin destruir el formulario)
function fallbackCheckout(wv,nm,ln,shortAddr,address2,dist,dep,prov,ref){
  // Re-habilitar botón de confirmar
  var btn=el('alhup-confirm-btn');
  if(btn){btn.disabled=false;var _btnText=el('alhup-confirm-btn-text');if(_btnText)_btnText.textContent='Confirmar pedido — Pago al recibir';}
  // Mostrar mensaje de error con opción de pedir por WhatsApp
  var packInfo=window.__alhupSelectedPack||{qty:1,price:89,pack:'1'};
  var packLabel=packInfo.qty===1?'1 frasco':packInfo.qty+' frascos';
  var waMsg=encodeURIComponent('Hola! Quiero pedir '+packLabel+' de Shilajit Ultra (S/'+packInfo.price+'). Mi dirección: '+shortAddr+', '+dist+', '+prov+', '+dep+'. WhatsApp: '+wv+(nm?' Nombre: '+nm+(ln&&ln!=='.'?' '+ln:''):''));
  // Show error inline without destroying the form (user keeps their data)
  var existingFallback=document.getElementById('alhup-fallback-error');
  if(existingFallback)existingFallback.remove();
  var errDiv=document.createElement('div');
  errDiv.id='alhup-fallback-error';
  errDiv.style.cssText='text-align:center;padding:16px;background:#fef2f2;border:1px solid #fecaca;border-radius:12px;margin:12px 0;';
  errDiv.innerHTML=
    '<p style="font-size:14px;color:#b91c1c;font-weight:700;margin-bottom:8px;">⚠️ Estamos procesando muchos pedidos</p>'+
    '<p style="font-size:13px;color:#374151;margin-bottom:12px;">Puedes completar tu pedido por WhatsApp o intentar de nuevo:</p>'+
    '<div style="display:flex;gap:8px;justify-content:center;flex-wrap:wrap;">'+
      '<a href="https://wa.me/51910214077?text='+waMsg+'" target="_blank" rel="noopener" '+
        'style="display:inline-flex;align-items:center;gap:6px;padding:10px 18px;background:#25D366;color:#fff;border-radius:10px;font-weight:700;font-size:14px;text-decoration:none;">'+
        '📱 Pedir por WhatsApp</a>'+
      '<button type="button" onclick="this.parentElement.parentElement.remove();AlhupMap.confirmOrder();" '+
        'style="padding:10px 18px;background:#1a1a2e;color:#fff;border:none;border-radius:10px;font-weight:700;font-size:14px;cursor:pointer;">'+
        '🔄 Reintentar</button>'+
    '</div>';
  if(btn)btn.parentElement.insertBefore(errDiv,btn);
  errDiv.scrollIntoView({behavior:'smooth',block:'center'});
}

// === INTERCEPTAR BOTONES ===
function interceptBuyNow(){
  if(!isProductPage())return;

  var sels='.shopify-payment-button button,.shopify-payment-button__button,'+
    '[data-shopify="payment-button"] button,button[name="checkout"],'+
    '.dynamic-checkout__content button,.product-form__cart-submit--buy-now';
  var btns=document.querySelectorAll(sels);
  for(var bi=0;bi<btns.length;bi++){(function(btn){
    if(btn.dataset.alhupIntercepted)return;
    btn.dataset.alhupIntercepted='1';
    btn.addEventListener('click',function(e){
      e.preventDefault();e.stopPropagation();e.stopImmediatePropagation();
      var form=document.querySelector('form[action*="/cart/add"]');
      var vi=form?form.querySelector('[name="id"],input[name="id"],select[name="id"]'):null;
      pendingVariantId=vi?vi.value:null;
      var qi=form?form.querySelector('[name="quantity"]'):null;
      pendingQty=qi?parseInt(qi.value)||1:1;
      AlhupMap.show();
      return false;
    },true);
  })(btns[bi]);}

  var addBtns=document.querySelectorAll('[name="add"],button[type="submit"][data-add-to-cart],.btn--add-to-cart,.product__submit,.add-to-cart-button,.product-form__cart-submit,form[action*="/cart/add"] button[type="submit"]');
  for(var ai=0;ai<addBtns.length;ai++){(function(btn){
    if(btn.dataset.alhupIntercepted)return;
    btn.dataset.alhupIntercepted='1';
    btn.addEventListener('click',function(e){
      e.preventDefault();e.stopPropagation();e.stopImmediatePropagation();
      var form=document.querySelector('form[action*="/cart/add"]');
      var vi=form?form.querySelector('[name="id"],input[name="id"],select[name="id"]'):null;
      pendingVariantId=vi?vi.value:null;
      var qi=form?form.querySelector('[name="quantity"]'):null;
      pendingQty=qi?parseInt(qi.value)||1:1;
      AlhupMap.show();
      return false;
    },true);
  })(addBtns[ai]);}

  // Interceptar submit del formulario (prevenir envío a /cart/add)
  var cartForms=document.querySelectorAll('form[action*="/cart/add"]');
  for(var fi=0;fi<cartForms.length;fi++){(function(form){
    if(form.dataset.alhupIntercepted)return;
    form.dataset.alhupIntercepted='1';
    form.addEventListener('submit',function(e){
      e.preventDefault();e.stopPropagation();
      var vi=form.querySelector('[name="id"],input[name="id"],select[name="id"]');
      pendingVariantId=vi?vi.value:null;
      var qi=form.querySelector('[name="quantity"]');
      pendingQty=qi?parseInt(qi.value)||1:1;
      AlhupMap.show();
      return false;
    },true);
  })(cartForms[fi]);}
}

document.addEventListener('DOMContentLoaded',function(){
  setTimeout(interceptBuyNow,800);
  setTimeout(interceptBuyNow,2500);
  setTimeout(interceptBuyNow,5000);
  // Initialize social proof counter
  AlhupMap._initSocialProof();
  // Initialize progress tracker
  AlhupMap._initProgress();
  // Auto-save de formulario (previene pérdida de datos si falla API)
  setTimeout(function(){AlhupMap._initAutoSave();},500);
  // Live notifications toast (refuerza social proof durante el scroll)
  AlhupMap._initLiveNotifications();
  // Pre-warm API al CARGAR la página (antes de que el usuario abra el picker)
  // Render.com cold-start es 30s; si lo calentamos ya, el primer POST es instantáneo
  if(/\/products\//.test(window.location.pathname)){
    setTimeout(function(){AlhupMap._warmApi();},1500);
    // Re-ping cada 4 min para mantenerlo caliente mientras el usuario navega
    setInterval(function(){AlhupMap._apiWarmed=false;AlhupMap._warmApi();},240000);
  }
  // Populate departments on load (for visible selects)
  setTimeout(function(){if(!mapInited){populateDeps();}},1000);
});

// === INLINE ERROR HELPERS ===
AlhupMap._showError=function(msg){
  var errEl=el('alhup-inline-error');
  var errText=el('alhup-inline-error-text');
  if(errEl&&errText){
    errText.textContent=msg;
    errEl.classList.add('show');
    errEl.scrollIntoView({behavior:'smooth',block:'center'});
    // Auto-hide after 5s
    clearTimeout(AlhupMap._errTimer);
    AlhupMap._errTimer=setTimeout(function(){AlhupMap._hideError();},5000);
  }
};
AlhupMap._hideError=function(){
  var errEl=el('alhup-inline-error');
  if(errEl)errEl.classList.remove('show');
};

// === SOCIAL PROOF ===
AlhupMap._initSocialProof=function(){
  var counter=el('alhup-social-count');
  if(!counter)return;
  // Random realistic count 12-34, session-based
  var key='alhup_social_count';
  var stored=sessionStorage.getItem(key);
  var count=stored?parseInt(stored):(Math.floor(Math.random()*23)+12);
  if(!stored)sessionStorage.setItem(key,String(count));
  counter.textContent=count+' personas pidieron hoy';
  // Slowly increment every 60-120 seconds
  setInterval(function(){
    count++;
    sessionStorage.setItem(key,String(count));
    counter.textContent=count+' personas pidieron hoy';
  },Math.floor(Math.random()*60000)+60000);
};

// === PROGRESS INDICATOR ===
AlhupMap._initProgress=function(){
  // Monitor inputs to update progress and show real-time validation
  var waInput=el('alhup-whatsapp');
  var fullnameInput=el('alhup-fullname');
  var inputs=[waInput,fullnameInput];
  inputs.forEach(function(inp){
    if(inp){
      inp.addEventListener('input',function(){AlhupMap._updateProgress();AlhupMap._validateFields();});
      inp.addEventListener('blur',function(){AlhupMap._validateFields();});
    }
  });
  // WhatsApp auto-formatting (add spaces: 9XX XXX XXX)
  if(waInput){
    waInput.addEventListener('input',function(){
      var raw=this.value.replace(/\D/g,'');
      // Strip leading country code if user pasted full number (+51... or 51...)
      if(raw.length>9&&raw.indexOf('51')===0)raw=raw.substring(2);
      // Strip leading 0 (some users type 09XX... instead of 9XX...)
      if(raw.length>0&&raw.charAt(0)==='0')raw=raw.substring(1);
      if(raw.length>9)raw=raw.substring(0,9);
      var formatted='';
      if(raw.length>0)formatted=raw.substring(0,Math.min(3,raw.length));
      if(raw.length>3)formatted+=' '+raw.substring(3,Math.min(6,raw.length));
      if(raw.length>6)formatted+=' '+raw.substring(6,9);
      if(this.value!==formatted){
        // Calculate correct cursor position based on digit count before cursor
        var cursorPos=this.selectionStart;
        var digitsBeforeCursor=this.value.substring(0,cursorPos).replace(/\D/g,'').length;
        this.value=formatted;
        // Map digit position to formatted position
        var newPos=0;var digitCount=0;
        for(var ci=0;ci<formatted.length;ci++){
          if(/\d/.test(formatted[ci])){digitCount++;}
          if(digitCount>=digitsBeforeCursor){newPos=ci+1;break;}
        }
        if(digitCount<digitsBeforeCursor)newPos=formatted.length;
        this.setSelectionRange(newPos,newPos);
      }
    });
    // Validate on blur — show error if invalid
    waInput.addEventListener('blur',function(){
      var raw=this.value.replace(/\D/g,'');
      var waErr=el('alhup-wa-err');
      if(raw.length>0&&(raw.length<9||!raw.startsWith('9'))){
        if(waErr)waErr.style.display='block';
      }else if(waErr){
        waErr.style.display='none';
      }
    });
  }
};
AlhupMap._updateProgress=function(){
  var wv=(el('alhup-whatsapp')||{value:''}).value.replace(/\D/g,'');
  var fullname=(el('alhup-fullname')||{value:''}).value.trim();
  var step1Done=wv.length>=9&&fullname.length>=3;

  var prog1=el('alhup-prog-1');
  var prog2=el('alhup-prog-2');
  var line1=el('alhup-prog-line1');
  var btn=el('alhup-confirm-btn');

  if(step1Done){
    if(prog1)prog1.classList.add('active');
    if(line1)line1.classList.add('active');
    if(prog2)prog2.classList.add('active');
    // Add pulse to confirm button when location is also filled
    var hasLocation=dist||dep||(el('alhup-dist')&&el('alhup-dist').value)||(el('alhup-dep')&&el('alhup-dep').value);
    if(btn&&hasLocation)btn.classList.add('pulse');
    // Update button text based on readiness
    var btnText=el('alhup-confirm-btn-text');
    if(btnText){
      if(hasLocation)btnText.textContent='Confirmar pedido — Pago al recibir';
      else btnText.textContent='Selecciona tu ubicación abajo ↓';
    }
    // Auto-prompt GPS on mobile when Step 1 completes (less intrusive than on open)
    if(AlhupMap._pendingGpsPrompt&&!AlhupMap._gpsPrompted){
      AlhupMap._gpsPrompted=true;
      setTimeout(function(){AlhupMap.useGPS();},400);
    }
    // Scroll to Step 2 on mobile for smooth flow
    if(!AlhupMap._scrolledToStep2&&window.innerWidth<=768){
      AlhupMap._scrolledToStep2=true;
      var step2Head=document.querySelector('.alhup-picker-step:nth-child(2) .alhup-picker-step__head,.alhup-section-divider');
      if(step2Head)setTimeout(function(){step2Head.scrollIntoView({behavior:'smooth',block:'start'});},200);
    }
  }else{
    if(prog2)prog2.classList.remove('active');
    if(line1)line1.classList.remove('active');
    if(btn)btn.classList.remove('pulse');
  }
};
// Real-time field validation with green checkmarks
AlhupMap._validateFields=function(){
  var wv=(el('alhup-whatsapp')||{value:''}).value.replace(/\D/g,'');
  var waCheck=el('alhup-wa-check');
  var waErr=el('alhup-wa-err');
  if(waCheck){
    if(wv.length>=9&&wv.startsWith('9')){waCheck.classList.add('show');if(waErr)waErr.style.display='none';}
    else{waCheck.classList.remove('show');}
  }
  var fullname=(el('alhup-fullname')||{value:''}).value.trim();
  var nameCheck=el('alhup-name-check');
  if(nameCheck){
    if(fullname.length>=3){nameCheck.classList.add('show');}
    else{nameCheck.classList.remove('show');}
  }
};
AlhupMap._markProgressDone=function(){
  var ids=['alhup-prog-1','alhup-prog-2','alhup-prog-3','alhup-prog-line1','alhup-prog-line2'];
  ids.forEach(function(id){var e=el(id);if(e)e.classList.add('active');});
};

// === ORDER SUMMARY UPDATE ===
AlhupMap._updateSummary=function(){
  // Fallback: si no hay pack seleccionado via JS, leer el DOM (.alhup-pack-card--selected)
  if(!window.__alhupSelectedPack){
    var selCard=document.querySelector('.alhup-pack-card--selected');
    if(selCard){
      window.__alhupSelectedPack={
        qty:parseInt(selCard.getAttribute('data-qty')||'1'),
        price:parseInt(selCard.getAttribute('data-price')||'89'),
        pack:selCard.getAttribute('data-pack')||'1',
        variantId:selCard.getAttribute('data-variant-id')||null
      };
    }
  }
  var packInfo=window.__alhupSelectedPack||{qty:1,price:89,pack:'1'};
  var packEl=el('alhup-summary-pack');
  var priceEl=el('alhup-summary-price');
  if(packEl){
    var label=packInfo.qty===1?'1 frasco':''+packInfo.qty+' frascos';
    packEl.textContent=label+' — Envío GRATIS';
  }
  if(priceEl)priceEl.textContent='S/'+packInfo.price;
  // Update WhatsApp fallback link with pack info
  var waLink=el('alhup-wa-direct');
  if(waLink){
    var packLabel2=packInfo.qty===1?'1 frasco':''+packInfo.qty+' frascos';
    var waMsg2=encodeURIComponent('Hola! Quiero pedir '+packLabel2+' de Shilajit Ultra (S/'+packInfo.price+'). Me ayudan?');
    waLink.href='https://wa.me/51910214077?text='+waMsg2;
  }
};

// === GPS NOTICE ===
AlhupMap._showGpsNotice=function(){
  var notice=el('alhup-gps-notice');
  if(notice&&lat&&lng)notice.style.display='block';
};

// === API PRE-WARM (Render.com cold start mitigation) ===
// OPTIONS preflight a /api/create-order es el warm-up más eficiente:
// wake-up Render + calentar CORS cache en una sola petición (~300ms si frío)
AlhupMap._warmApi=function(){
  if(AlhupMap._apiWarmed)return;
  AlhupMap._apiWarmed=true;
  try{
    // OPTIONS preflight (mismo endpoint que usamos luego — garantiza warm)
    fetch('https://alhup-whatsapp-bot.onrender.com/api/create-order',{
      method:'OPTIONS',
      headers:{'Content-Type':'application/json'},
      mode:'cors'
    }).catch(function(){
      // Fallback: ping al root (cualquier request despierta Render)
      fetch('https://alhup-whatsapp-bot.onrender.com/',{method:'GET',mode:'no-cors'}).catch(function(){});
    });
  }catch(e){}
};

// === FORM DATA PERSISTENCE ===
AlhupMap._saveFormData=function(){
  try{
    var data={
      wa:(el('alhup-whatsapp')||{}).value||'',
      name:(el('alhup-fullname')||{}).value||'',
      ref:(el('alhup-ref')||{}).value||'',
      dep:dep,prov:prov,dist:dist,addr:addr,lat:lat,lng:lng,
      ts:Date.now()
    };
    localStorage.setItem('alhup_order_draft',JSON.stringify(data));
  }catch(e){}
};
AlhupMap._restoreFormData=function(){
  try{
    var raw=localStorage.getItem('alhup_order_draft');
    if(!raw)return;
    var data=JSON.parse(raw);
    if(!data||(Date.now()-data.ts)>86400000){localStorage.removeItem('alhup_order_draft');return;}
    var wa=el('alhup-whatsapp');if(wa&&data.wa&&!wa.value)wa.value=data.wa;
    var fn=el('alhup-fullname');if(fn&&data.name&&!fn.value)fn.value=data.name;
    if(data.ref){
      var refEl=el('alhup-ref');if(refEl){refEl.value=data.ref;var rw=el('alhup-ref-wrap');if(rw)rw.style.display='block';var rl=el('alhup-add-ref-link');if(rl)rl.style.display='none';}
    }
    setTimeout(function(){AlhupMap._validateFields();AlhupMap._updateProgress();},100);
  }catch(e){}
};
AlhupMap._clearFormData=function(){try{localStorage.removeItem('alhup_order_draft');}catch(e){}};

// Auto-save on input (debounced)
AlhupMap._initAutoSave=function(){
  var timer;
  function save(){clearTimeout(timer);timer=setTimeout(AlhupMap._saveFormData,600);}
  ['alhup-whatsapp','alhup-fullname','alhup-ref'].forEach(function(id){
    var e=el(id);if(e)e.addEventListener('input',save);
  });
};

// === PROGRESSIVE LOADER (cold start feedback) ===
AlhupMap._startProgressiveLoader=function(){
  var btn=el('alhup-confirm-btn');
  if(btn){btn.disabled=true;btn.classList.remove('pulse');}
  var btnText=el('alhup-confirm-btn-text');
  if(!btnText)return;
  var messages=[
    {t:0,   m:'📦 Guardando tu pedido...'},
    {t:3000,m:'🔒 Verificando tu información...'},
    {t:7000,m:'🚚 Asignando repartidor cercano...'},
    {t:12000,m:'⏳ Confirmando stock... casi listo'},
    {t:18000,m:'⏳ Un momento más, procesando...'},
    {t:25000,m:'⏳ Servidor activándose, ya casi...'}
  ];
  AlhupMap._loaderTimers=[];
  messages.forEach(function(msg){
    var t=setTimeout(function(){if(btnText)btnText.innerHTML='<span class="alhup-loader-spin"></span> '+msg.m;},msg.t);
    AlhupMap._loaderTimers.push(t);
  });
};
AlhupMap._loaderMsg=function(m){
  var btnText=el('alhup-confirm-btn-text');
  if(btnText)btnText.innerHTML='<span class="alhup-loader-spin"></span> '+m;
};
AlhupMap._stopProgressiveLoader=function(){
  if(AlhupMap._loaderTimers)AlhupMap._loaderTimers.forEach(function(t){clearTimeout(t);});
  AlhupMap._loaderTimers=[];
  var btn=el('alhup-confirm-btn');if(btn)btn.disabled=false;
  var btnText=el('alhup-confirm-btn-text');if(btnText)btnText.textContent='Confirmar pedido — Pago al recibir';
};

// === DYNAMIC STOCK COUNTER (decrementa lentamente — scarcity realista) ===
AlhupMap._initStockCounter=function(){
  var stockEl=el('alhup-stock-num');
  if(!stockEl)return;
  var key='alhup_stock_count';
  var stored=parseInt(sessionStorage.getItem(key)||'0');
  // Inicializa entre 7 y 12 (realista, no obvio)
  if(!stored||stored<3||stored>15){stored=Math.floor(Math.random()*6)+7;sessionStorage.setItem(key,String(stored));}
  stockEl.textContent=stored;
  // Decremento aleatorio: -1 cada 2-5 min (pero nunca bajo 3)
  function tick(){
    var cur=parseInt(sessionStorage.getItem(key)||'0');
    if(cur>3){
      cur--;
      sessionStorage.setItem(key,String(cur));
      if(stockEl){
        stockEl.textContent=cur;
        stockEl.style.animation='none';
        setTimeout(function(){stockEl.style.animation='alhup-pulse-dot 0.6s ease';},10);
      }
    }
  }
  var nextDelay=function(){return (Math.floor(Math.random()*180)+120)*1000;};
  function schedule(){setTimeout(function(){tick();schedule();},nextDelay());}
  schedule();
};

// === URGENCY COUNTDOWN (15 min per session — creates urgency for TikTok traffic) ===
AlhupMap._startUrgencyTimer=function(){
  var el2=el('alhup-urgency-timer');
  if(!el2)return;
  var key='alhup_urgency_end';
  var endTs=parseInt(sessionStorage.getItem(key)||'0');
  var now=Date.now();
  if(!endTs||endTs<now){endTs=now+15*60*1000;sessionStorage.setItem(key,String(endTs));}
  function tick(){
    var rem=Math.max(0,endTs-Date.now());
    var mm=Math.floor(rem/60000);
    var ss=Math.floor((rem%60000)/1000);
    el2.textContent=(mm<10?'0':'')+mm+':'+(ss<10?'0':'')+ss;
    if(rem<=0){clearInterval(AlhupMap._urgencyInterval);sessionStorage.removeItem(key);var box=el('alhup-urgency-box');if(box)box.style.display='none';}
  }
  tick();
  clearInterval(AlhupMap._urgencyInterval);
  AlhupMap._urgencyInterval=setInterval(tick,1000);
};

// === FAKE LIVE NOTIFICATION TOAST (social proof reforzada) ===
AlhupMap._initLiveNotifications=function(){
  if(!/\/products\//.test(window.location.pathname))return;
  var names=['María de Lima','Carlos de SJL','Ana de Trujillo','Luis de Arequipa','Rosa de Chiclayo','Jorge de Callao','Lucía de Piura','Diego de Cusco','Carmen de Surco','Miguel de Los Olivos','Patricia de Comas','Kevin de Ate'];
  var times=['hace 2 min','hace 4 min','hace 6 min','hace 9 min','hace 12 min'];
  var packs=['1 frasco','2 frascos','3 frascos'];
  function show(){
    if(document.getElementById('alhup-live-toast'))return;
    var t=document.createElement('div');
    t.id='alhup-live-toast';
    t.className='alhup-live-toast';
    var n=names[Math.floor(Math.random()*names.length)];
    var p=packs[Math.floor(Math.random()*packs.length)];
    var tm=times[Math.floor(Math.random()*times.length)];
    t.innerHTML='<span class="alhup-live-toast__dot"></span><div><strong>'+n+'</strong> pidió '+p+'<br><small>'+tm+'</small></div><span class="alhup-live-toast__close" onclick="this.parentElement.remove()">×</span>';
    document.body.appendChild(t);
    setTimeout(function(){if(t.parentElement)t.remove();},6000);
  }
  setTimeout(show,8000);
  setInterval(show,45000);
};
// Re-intercept on mutations (web components rendering later)
if(typeof MutationObserver!=='undefined'){
  var _obsBounce;
  var _obs=new MutationObserver(function(){clearTimeout(_obsBounce);_obsBounce=setTimeout(interceptBuyNow,200);});
  _obs.observe(document.body,{childList:true,subtree:true});
  // No disconnect — keep watching for dynamically added buttons
}

// === STICKY CTA BAR (sutil — solo cuando el form no está visible) ===
// === STICKY CTA BAR — Delegado a alhup-mobile-sticky-cta.liquid ===
// (Server-rendered snippet maneja visibilidad — evita duplicar ID #alhup-sticky-cta)
(function(){
  if(!/\/products\//.test(window.location.pathname))return;
  // Ocultar sticky CTA cuando el picker está visible en viewport
  var _stickyTimer=null;
  function _stickyCheck(){
    var bar=document.getElementById('alhup-sticky-cta');
    if(!bar)return;
    var picker=el('alhup-location-picker');
    if(!picker||picker.style.display==='none'){bar.classList.remove('alhup-sticky-cta--hidden');return;}
    var rect=picker.getBoundingClientRect();
    if(rect.top<window.innerHeight&&rect.bottom>0){bar.classList.add('alhup-sticky-cta--hidden');}
    else{bar.classList.remove('alhup-sticky-cta--hidden');}
  }
  window.addEventListener('scroll',function(){
    if(_stickyTimer)return;
    _stickyTimer=setTimeout(function(){_stickyTimer=null;_stickyCheck();},150);
  },false);
  setTimeout(_stickyCheck,3000);
})();

// === HUMANIZED MICRO-INTERACTIONS ===
// En vez de popups invasivos, usamos señales sutiles que guían sin interrumpir
(function(){
  if(!/\/products\//.test(window.location.pathname))return;

  // 1. Gentle scroll hint: cuando el usuario llega a la zona del producto,
  //    el header del form hace un breve "breathing" para llamar la atención
  var _hintShown=false;
  var _hintObs=null;
  document.addEventListener('DOMContentLoaded',function(){
    setTimeout(function(){
      var picker=el('alhup-location-picker');
      if(!picker||typeof IntersectionObserver==='undefined')return;
      _hintObs=new IntersectionObserver(function(entries){
        if(_hintShown)return;
        for(var i=0;i<entries.length;i++){
          if(entries[i].isIntersecting){
            _hintShown=true;
            // Sutil breathing animation en el header
            var header=picker.querySelector('.alhup-picker-header');
            if(header){
              header.classList.add('alhup-breathe');
              setTimeout(function(){header.classList.remove('alhup-breathe');},3000);
            }
            if(_hintObs)_hintObs.disconnect();
            break;
          }
        }
      },{threshold:0.3});
      _hintObs.observe(picker);
    },2000);
  });

  // 2. Warm welcome message: cuando el usuario abre el form por primera vez,
  //    mostrar un mensajito amigable que desaparece solo
  var _origShow=AlhupMap.show;
  var _welcomed=false;
  AlhupMap.show=function(){
    _origShow.call(this);
    if(_welcomed)return;
    _welcomed=true;
    try{if(sessionStorage.getItem('alhup_welcomed'))return;}catch(e){}
    try{sessionStorage.setItem('alhup_welcomed','1');}catch(e){}
    // Crear welcome toast sutil arriba del form
    var picker=el('alhup-location-picker');
    if(!picker)return;
    var toast=document.createElement('div');
    toast.className='alhup-welcome-toast';
    toast.innerHTML='\uD83D\uDC4B \u00A1Hola! Solo necesitamos tu WhatsApp y ubicaci\u00F3n para enviarte el producto.';
    var body=el('alhup-picker-body');
    if(body)body.insertBefore(toast,body.firstChild);
    // Desaparece suavemente después de 5s
    setTimeout(function(){
      toast.style.opacity='0';
      toast.style.transition='opacity 0.5s ease';
      setTimeout(function(){if(toast.parentElement)toast.remove();},500);
    },5000);
  };

  // 3. Step completion celebration: micro-feedback positivo cuando completa cada paso
  //    (no intrusivo — solo un cambio de color sutil y un emoji)
  var _step1Celebrated=false;
  document.addEventListener('DOMContentLoaded',function(){
    setTimeout(function(){
      var waInput=el('alhup-whatsapp');
      var fnInput=el('alhup-fullname');
      function checkStep1(){
        if(_step1Celebrated)return;
        var wv=(el('alhup-whatsapp')||{value:''}).value.replace(/\D/g,'');
        var fn=(el('alhup-fullname')||{value:''}).value.trim();
        if(wv.length>=9&&wv.startsWith('9')&&fn.length>=3){
          _step1Celebrated=true;
          // Mini celebration: cambiar badge de Step 1 a check verde
          var badge1=document.querySelector('#alhup-prog-1 .alhup-progress__dot');
          if(badge1){badge1.textContent='\u2713';badge1.style.background='#16a34a';badge1.style.color='#fff';}
          // Mostrar mensajito debajo de Step 1
          var contactStep=el('alhup-contact-step');
          if(contactStep){
            var msg=document.createElement('div');
            msg.className='alhup-step-done-msg';
            msg.textContent='\u2705 Perfecto \u2014 ahora indica tu direcci\u00F3n de entrega';
            contactStep.appendChild(msg);
            // Fade out después de 4s
            setTimeout(function(){
              msg.style.opacity='0';msg.style.transition='opacity 0.5s';
              setTimeout(function(){if(msg.parentElement)msg.remove();},500);
            },4000);
          }
        }
      }
      if(waInput)waInput.addEventListener('input',function(){setTimeout(checkStep1,300);});
      if(fnInput)fnInput.addEventListener('input',function(){setTimeout(checkStep1,300);});
      if(fnInput)fnInput.addEventListener('blur',checkStep1);
    },2000);
  });

  // 4. Typing encouragement: cuando el usuario empieza a escribir el WhatsApp,
  //    el hint cambia a un mensaje de progreso
  document.addEventListener('DOMContentLoaded',function(){
    setTimeout(function(){
      var waInput=el('alhup-whatsapp');
      var hint=document.querySelector('.alhup-whatsapp-hint');
      if(!waInput||!hint)return;
      var origHint=hint.textContent;
      waInput.addEventListener('input',function(){
        var raw=this.value.replace(/\D/g,'');
        if(raw.length===0){hint.textContent=origHint;}
        else if(raw.length<9){hint.textContent='\u270F\uFE0F Faltan '+(9-raw.length)+' d\u00EDgitos...';}
        else if(raw.startsWith('9')){hint.textContent='\u2705 N\u00FAmero v\u00E1lido \u2014 te contactaremos por WhatsApp';}
        else{hint.textContent='\u26A0\uFE0F El n\u00FAmero debe empezar con 9';}
      });
    },2000);
  });
})();

})();
